module.exports = __webpack_public_path__ + "img/sensornode.88216e57.jpeg";